import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import InfoTooltip from './InfoTooltip';
import InputFeedback from './InputFeedback';

/* source: https://www.w3schools.com/howto/howto_css_custom_checkbox.asp */

const StyledCheckbox = styled.label`
  font-family: ${props => props.theme.fonts.main};
  /* background-color: lightsalmon; */
  display: block;
  color: ${({ disabled }) => (disabled ? '#b3b3b3' : 'unset')};
  position: relative;
  padding-left: ${props => (props.size ? props.size * 35 + 'px' : '35px')};
  margin-bottom: 12px;
  font-size: ${props => (props.size ? props.size * 22 + 'px' : '22px')};
  cursor: pointer;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    background-color: #eee;
    position: absolute;
    top: 0;
    left: 0;
    height: ${props => (props.size ? props.size * 25 + 'px' : '25px')};
    width: ${props => (props.size ? props.size * 25 + 'px' : '25px')};
    /* border 2px solid black; */
    border-radius: 5px;
  }

  &:hover input ~ .checkmark {
    background-color: ${({ disabled }) => (disabled ? '#eee' : '#ccc')};
  }

  & input:checked ~ .checkmark {
    background-color: ${props => props.theme.colors.secondary};
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  & input:checked ~ .checkmark:after {
    display: block;
  }

  & .checkmark:after {
    left: ${props => (props.size ? props.size * 9 + 'px' : '9px')};
    top: ${props => (props.size ? props.size * 5 + 'px' : '5px')};
    width: ${props => (props.size ? props.size * 7 + 'px' : '7px')};
    height: ${props => (props.size ? props.size * 12 + 'px' : '12px')};
    border: solid white;
    border-width: ${props =>
      props.size
        ? '0 ' + props.size * 3 + 'px ' + props.size * 3 + 'px 0'
        : '0 3px 3px 0'};
    transform: rotate(45deg);
  }
`;

/* Checkbox to be used by Formik */

const FormikCheckbox = ({
  field: { name, value, onChange, onBlur },
  form: { errors, touched, setFieldValue },
  id,
  label,
  className,
  size,
  children,
  disabled = false,
  tooltip,
  ...props
}) => {
  return (
    <StyledCheckbox size={size} disabled={disabled}>
      {children}
      <input
        name={name}
        id={id}
        type='checkbox'
        value={value}
        checked={value}
        onChange={onChange}
        onBlur={onBlur}
        className={'radio-button'}
        disabled={disabled}
      />
      <span className='checkmark' />
      {tooltip ? <InfoTooltip tooltip={tooltip} /> : null}
      {touched[name] && <InputFeedback error={errors[name]} />}
    </StyledCheckbox>
  );
};

FormikCheckbox.propTypes = {
  size: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default FormikCheckbox;
